// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.device-detail-redesign-layout {
    min-height: 100vh;
  }
  
  .device-detail-redesign-content {
    flex: 1 1;
    min-width: 0;
    padding: 30px 36px;
    background: #f5f7fb;
  }
  
  .dd-page {
    width: 100%;
    color: #203047;
  }
  
  .dd-top {
    margin-bottom: 22px;
  }
  
  .dd-back {
    border: none;
    background: transparent;
    color: #64748b;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    padding: 0;
  }
  
  .dd-back:hover {
    color: #168ff0;
  }
  
  .dd-heading {
    margin-bottom: 24px;
  }
  
  .dd-heading h2 {
    margin: 0 0 8px;
    font-size: 25px;
    font-weight: 800;
    color: #203047;
  }
  
  .dd-heading p {
    margin: 0;
    font-size: 14px;
    color: #8190a4;
  }
  
  .dd-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 22px;
  }
  
  .dd-card {
    min-width: 0;
    background: #fff;
    border: 1px solid #e4eaf1;
    border-radius: 12px;
    padding: 26px;
    box-shadow: 0 2px 12px #19355409;
  }
  
  .dd-card-title {
    padding-bottom: 18px;
    margin-bottom: 8px;
    border-bottom: 1px solid #e9edf3;
  }
  
  .dd-card-title h3 {
    margin: 0 0 6px;
    font-size: 19px;
    font-weight: 800;
  }
  
  .dd-card-subtitle {
    font-size: 13px;
    color: #8190a4;
  }
  
  .dd-info-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    min-height: 76px;
    padding: 16px 0;
    border-bottom: 1px solid #eef1f5;
  }
  
  .dd-info-row:last-child {
    border-bottom: none;
  }
  
  .dd-info-row > span {
    flex-shrink: 0;
    color: #75849a;
    font-size: 15px;
    font-weight: 600;
  }
  
  .dd-info-row > strong {
    min-width: 0;
    font-size: 16px;
    font-weight: 700;
    text-align: right;
    overflow-wrap: anywhere;
  }
  
  .dd-badge {
    display: inline-block;
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
  }
  
  .dd-badge.installed,
  .dd-badge.normal {
    color: #15803d;
    background: #dcfce7;
  }
  
  .dd-badge.not-installed,
  .dd-badge.abnormal {
    color: #dc2626;
    background: #fee2e2;
  }
  
  .dd-badge.unknown {
    color: #64748b;
    background: #f1f5f9;
  }
  
  .dd-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
  }
  
  .dd-actions button {
    border-radius: 9px;
    padding: 13px 24px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
  }
  
  .dd-primary {
    border: 1px solid #168ff0;
    background: #168ff0;
    color: #fff;
  }
  
  .dd-secondary {
    border: 1px solid #dce4ee;
    background: #fff;
    color: #475569;
  }
  
  @media (max-width: 1100px) {
    .dd-grid {
      grid-template-columns: 1fr;
    }
  }
  
  @media (max-width: 768px) {
    .device-detail-redesign-content {
      padding: 20px 16px;
    }
  
    .dd-card {
      padding: 20px;
    }
  
    .dd-info-row {
      min-height: 64px;
    }
  }
  

/* 사용자 기본 정보 + 장비 3종 통합 레이아웃 */
.dd-overview {
    display: flex;
    flex-direction: column;
    gap: 22px;
  }
  
  .dd-user-info {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px;
    padding-top: 16px;
  }
  
  .dd-user-info > div {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 8px 0;
  }
  
  .dd-user-info > div > span,
  .dd-device-field > span,
  .dd-response-card > span {
    color: #75849a;
    font-size: 14px;
    font-weight: 600;
  }
  
  .dd-user-info strong {
    font-size: 16px;
    color: #203047;
  }
  
  .dd-device-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 22px;
  }
  
  .dd-device-card {
    display: flex;
    flex-direction: column;
    min-width: 0;
    min-height: 285px;
  }
  
  .dd-device-field {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 15px 0;
  }
  
  .dd-device-field + .dd-device-field {
    border-top: 1px solid #eef1f5;
  }
  
  .dd-device-id-box {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 12px;
    border: 1px solid #e4eaf1;
    border-radius: 8px;
    background: #f7f9fc;
    min-width: 0;
  }
  
  .dd-device-id {
    flex: 1 1;
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
    white-space: normal;
    font-size: 13px;
    line-height: 1.6;
    color: #203047;
  }
  
  .dd-copy {
    flex-shrink: 0;
    padding: 5px 9px;
    border: 1px solid #dce4ee;
    border-radius: 6px;
    background: #fff;
    color: #51759d;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
  }
  
  .dd-copy:hover {
    background: #edf5ff;
  }
  
  .dd-response-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }
  
  .dd-response-card strong {
    font-size: 16px;
  }
  
  @media (max-width: 1100px) {
    .dd-device-grid {
      grid-template-columns: 1fr;
    }
  
    .dd-device-card {
      min-height: 0;
    }
  }
  
  @media (max-width: 768px) {
    .dd-user-info {
      grid-template-columns: 1fr;
      gap: 12px;
    }
  }
  
`, "",{"version":3,"sources":["webpack://./src/components/device/DeviceDetailRedesign.css"],"names":[],"mappings":";AACA;IACI,iBAAiB;EACnB;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,cAAc;IACd,mBAAmB;EACrB;;EAEA;;IAEE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE;MACE,0BAA0B;IAC5B;EACF;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,gBAAgB;IAClB;EACF;;;AAGF,8BAA8B;AAC9B;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;EAChB;;EAEA;;;IAGE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE;MACE,0BAA0B;IAC5B;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,0BAA0B;MAC1B,SAAS;IACX;EACF","sourcesContent":["\r\n.device-detail-redesign-layout {\r\n    min-height: 100vh;\r\n  }\r\n  \r\n  .device-detail-redesign-content {\r\n    flex: 1;\r\n    min-width: 0;\r\n    padding: 30px 36px;\r\n    background: #f5f7fb;\r\n  }\r\n  \r\n  .dd-page {\r\n    width: 100%;\r\n    color: #203047;\r\n  }\r\n  \r\n  .dd-top {\r\n    margin-bottom: 22px;\r\n  }\r\n  \r\n  .dd-back {\r\n    border: none;\r\n    background: transparent;\r\n    color: #64748b;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    padding: 0;\r\n  }\r\n  \r\n  .dd-back:hover {\r\n    color: #168ff0;\r\n  }\r\n  \r\n  .dd-heading {\r\n    margin-bottom: 24px;\r\n  }\r\n  \r\n  .dd-heading h2 {\r\n    margin: 0 0 8px;\r\n    font-size: 25px;\r\n    font-weight: 800;\r\n    color: #203047;\r\n  }\r\n  \r\n  .dd-heading p {\r\n    margin: 0;\r\n    font-size: 14px;\r\n    color: #8190a4;\r\n  }\r\n  \r\n  .dd-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 22px;\r\n  }\r\n  \r\n  .dd-card {\r\n    min-width: 0;\r\n    background: #fff;\r\n    border: 1px solid #e4eaf1;\r\n    border-radius: 12px;\r\n    padding: 26px;\r\n    box-shadow: 0 2px 12px #19355409;\r\n  }\r\n  \r\n  .dd-card-title {\r\n    padding-bottom: 18px;\r\n    margin-bottom: 8px;\r\n    border-bottom: 1px solid #e9edf3;\r\n  }\r\n  \r\n  .dd-card-title h3 {\r\n    margin: 0 0 6px;\r\n    font-size: 19px;\r\n    font-weight: 800;\r\n  }\r\n  \r\n  .dd-card-subtitle {\r\n    font-size: 13px;\r\n    color: #8190a4;\r\n  }\r\n  \r\n  .dd-info-row {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 20px;\r\n    min-height: 76px;\r\n    padding: 16px 0;\r\n    border-bottom: 1px solid #eef1f5;\r\n  }\r\n  \r\n  .dd-info-row:last-child {\r\n    border-bottom: none;\r\n  }\r\n  \r\n  .dd-info-row > span {\r\n    flex-shrink: 0;\r\n    color: #75849a;\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .dd-info-row > strong {\r\n    min-width: 0;\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n    text-align: right;\r\n    overflow-wrap: anywhere;\r\n  }\r\n  \r\n  .dd-badge {\r\n    display: inline-block;\r\n    padding: 8px 16px;\r\n    border-radius: 8px;\r\n    font-size: 13px;\r\n    font-weight: 700;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  .dd-badge.installed,\r\n  .dd-badge.normal {\r\n    color: #15803d;\r\n    background: #dcfce7;\r\n  }\r\n  \r\n  .dd-badge.not-installed,\r\n  .dd-badge.abnormal {\r\n    color: #dc2626;\r\n    background: #fee2e2;\r\n  }\r\n  \r\n  .dd-badge.unknown {\r\n    color: #64748b;\r\n    background: #f1f5f9;\r\n  }\r\n  \r\n  .dd-actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 12px;\r\n    margin-top: 24px;\r\n  }\r\n  \r\n  .dd-actions button {\r\n    border-radius: 9px;\r\n    padding: 13px 24px;\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .dd-primary {\r\n    border: 1px solid #168ff0;\r\n    background: #168ff0;\r\n    color: #fff;\r\n  }\r\n  \r\n  .dd-secondary {\r\n    border: 1px solid #dce4ee;\r\n    background: #fff;\r\n    color: #475569;\r\n  }\r\n  \r\n  @media (max-width: 1100px) {\r\n    .dd-grid {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .device-detail-redesign-content {\r\n      padding: 20px 16px;\r\n    }\r\n  \r\n    .dd-card {\r\n      padding: 20px;\r\n    }\r\n  \r\n    .dd-info-row {\r\n      min-height: 64px;\r\n    }\r\n  }\r\n  \r\n\r\n/* 사용자 기본 정보 + 장비 3종 통합 레이아웃 */\r\n.dd-overview {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 22px;\r\n  }\r\n  \r\n  .dd-user-info {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, minmax(0, 1fr));\r\n    gap: 20px;\r\n    padding-top: 16px;\r\n  }\r\n  \r\n  .dd-user-info > div {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n    padding: 8px 0;\r\n  }\r\n  \r\n  .dd-user-info > div > span,\r\n  .dd-device-field > span,\r\n  .dd-response-card > span {\r\n    color: #75849a;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .dd-user-info strong {\r\n    font-size: 16px;\r\n    color: #203047;\r\n  }\r\n  \r\n  .dd-device-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, minmax(0, 1fr));\r\n    gap: 22px;\r\n  }\r\n  \r\n  .dd-device-card {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-width: 0;\r\n    min-height: 285px;\r\n  }\r\n  \r\n  .dd-device-field {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n    padding: 15px 0;\r\n  }\r\n  \r\n  .dd-device-field + .dd-device-field {\r\n    border-top: 1px solid #eef1f5;\r\n  }\r\n  \r\n  .dd-device-id-box {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n    padding: 12px;\r\n    border: 1px solid #e4eaf1;\r\n    border-radius: 8px;\r\n    background: #f7f9fc;\r\n    min-width: 0;\r\n  }\r\n  \r\n  .dd-device-id {\r\n    flex: 1;\r\n    min-width: 0;\r\n    overflow-wrap: anywhere;\r\n    word-break: break-word;\r\n    white-space: normal;\r\n    font-size: 13px;\r\n    line-height: 1.6;\r\n    color: #203047;\r\n  }\r\n  \r\n  .dd-copy {\r\n    flex-shrink: 0;\r\n    padding: 5px 9px;\r\n    border: 1px solid #dce4ee;\r\n    border-radius: 6px;\r\n    background: #fff;\r\n    color: #51759d;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .dd-copy:hover {\r\n    background: #edf5ff;\r\n  }\r\n  \r\n  .dd-response-card {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 16px;\r\n  }\r\n  \r\n  .dd-response-card strong {\r\n    font-size: 16px;\r\n  }\r\n  \r\n  @media (max-width: 1100px) {\r\n    .dd-device-grid {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  \r\n    .dd-device-card {\r\n      min-height: 0;\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .dd-user-info {\r\n      grid-template-columns: 1fr;\r\n      gap: 12px;\r\n    }\r\n  }\r\n  \r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
